import { useResponsiveHelper } from "@myinnsworth/hooks/responsiveHelperHook";
import Paging from "components/paging/paging";
import { ReactNode } from "react";

export interface ITableHeader {
    width?: number | string | undefined;
    name: string;
}

export interface ITableRow {
    cells: Array<ReactNode>;
}

export interface ITableProps {
    headers?: Array<ITableHeader | string>;
    rows: Array<ITableRow>;
    currentPage?: number;
    resultsPerPage?: number;
    totalResults?: number;
    allowPaging: boolean;
    nameIndex?: number;
    actionIndex?: number;
    hiddenIndices?: number[];
    onChangePage?: (pageNo: number) => void;
}

export default function Table(props:ITableProps) {
    const { isMobile } = useResponsiveHelper();

    return (
        <>
            {!isMobile && <div className="table-container mt-m">
                <table >
                    <thead>
                        <tr className="header">
                            {props.headers!.map((header: any, index: number) => {
                                if (typeof header === 'object') {
                                    if (header.hasOwnProperty('width') && header.hasOwnProperty('name')) {
                                        return (
                                            <th key={index} style={{ width: header.width }}>
                                                {header.name}
                                            </th>
                                        )
                                    } else if (header.hasOwnProperty('name')) {
                                        return (
                                            <th key={index} >
                                                {header.name}
                                            </th>
                                        )
                                    } else {
                                        return (
                                            <th key={index} style={{ width: header.width }}>
                                                {header}
                                            </th>
                                        )
                                    }
                                } else {
                                    return (
                                        <th key={index}>
                                            {header}
                                        </th>
                                    );
                                }
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {/* {rows.map((row: any, index: any) => (row))} */}
                        {props.rows.map((row: any, index: number) => (
                            <tr key={index}>
                                {row.cells.map((cell: any) => (<td>{cell}</td>))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>}

            {isMobile &&
                <div className="responsive-table-container">
                    {props.rows?.map((row: any, index: number) =>
                    (
                        <div key={index} className="responsive-table-row">
                            <h6>{row?.cells[props.nameIndex ?? 0]}</h6>
                            <div className="content">
                                {row?.cells?.map((cell: any, cellIndex: number) => {
                                    if (cellIndex !== props.nameIndex && cellIndex !== props.actionIndex && (!props.hiddenIndices || props.hiddenIndices?.filter(x => x === cellIndex).length === 0)) {
                                        if (typeof props.headers![cellIndex] === 'object') {
                                            if (typeof props.headers![cellIndex] === 'object') {
                                                return (
                                                    <div className="cell" key={cellIndex}> <span>{(props.headers![cellIndex] as ITableHeader).name}:</span> {cell}</div>
                                                );
                                            } else {
                                                return (
                                                    <div className="cell" key={cellIndex}> <span>{props.headers![cellIndex] as string}:</span> {cell}</div>
                                                );
                                            }
                                        } else {
                                            return (
                                                <div className="cell" key={cellIndex}> <span>{props.headers![cellIndex] as string}:</span> {cell}</div>
                                            );
                                        }
                                    } else { return (<></>); }
                                })}

                                {props.actionIndex && (
                                    <div className="flex justify-right responsive-table-action-row">
                                        {row?.cells[props.actionIndex]}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                    }
                </div>
            }

            {(props.allowPaging && props.currentPage !== undefined && props.totalResults !== undefined && props.resultsPerPage !== undefined) && 
                <Paging currentPage={props.currentPage} 
                        totalResults={props.totalResults} 
                        resultsPerPage={props.resultsPerPage} 
                        onChangePage={pageNo => { if(props.onChangePage) props.onChangePage(pageNo);} }
                />}
        </>
    )
} 